import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-white py-16 lg:py-20" data-id="element-67" data-mp="4uqdmw6js2tb">
      <div className="mx-auto max-w-content px-6" data-id="element-68" data-mp="4xcksupj0gb0">
        <div className="flex flex-col items-center gap-8 rounded-3xl border border-nature/30 bg-nature-soft/40 px-6 py-10 text-center sm:px-12 md:flex-row md:gap-12 md:text-left" data-id="element-69" data-mp="9u37w1zr0c5x">
          <div className="flex h-28 w-28 shrink-0 flex-col items-center justify-center rounded-full bg-nature text-white" data-id="element-70" data-mp="jt29x1q0d9jy">
            <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-71" data-mp="nt2ocmd3xkr0" />
            <span className="mt-1 font-display text-2xl font-extrabold leading-none" data-id="element-72" data-mp="sl49yyw60ntp">
              7
            </span>
            <span className="text-[11px] font-semibold uppercase tracking-[0.14em]" data-id="element-73" data-mp="xk74vqifldny">
              días
            </span>
          </div>

          <div data-id="element-74" data-mp="12kv06odp0gnz">
            <h2 className="font-display text-2xl font-bold leading-tight tracking-tight text-ink sm:text-3xl" data-id="element-75" data-mp="12h78zvvq06cf">
              Garantía de 7 días
            </h2>
            <p className="mt-3 max-w-xl text-lg leading-relaxed text-ink-soft" data-id="element-76" data-mp="25sqb5axqivas">
              Si no te gusta el contenido te devolvemos el dinero sin ninguna
              pregunta.{' '}
              <span className="font-semibold text-ink" data-id="element-77" data-mp="1vusjsekkwidy">Quedate tranquilo.</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}